module.exports = __webpack_public_path__ + "static/media/pyramid_s.09f515b9.svg";